module.exports = __webpack_public_path__ + "img/mco.ce438187.svg";